// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q-55","colMin":"styles_colMin__JYIGK"};